import { GenericObject, copyFields } from '@synergy/models';

import { ActivityComment } from './activity-comment';
import { User } from './user';

export class Activity {
    public id!: number;
    public groupId!: string;
    public changeSet?: GenericObject;
    public comments: ActivityComment[] = [];
    public loggedAt!: string;
    public action?: ActivityAction;
    public user!: User;
    /** The log's own identifier of who changed it, where the relation is empty. */
    public username?: string;
    public version!: number;
    public objectClass?: ActivityObjectClass;
    public objectId?: number;
    public rootObjectClass?: ActivityObjectClass;
    public rootObjectId?: number;
    public parentObjectClass?: ActivityObjectClass;
    public parentObjectId?: number;

    public static fromPlainObject(object: GenericObject): Activity {
        const activity = new Activity();

        copyFields(object, activity);

        if (object['comments']) {
            activity.comments = object['comments'].map(ActivityComment.fromPlainObject);
        }

        if (object['user']) {
            activity.user = User.fromPlainObject(object['user']);
        }

        return activity;
    }
}

export enum ActivityAction {
    Create = 'create',
    Remove = 'remove',
    Update = 'update',
}

export enum ActivityObjectClass {
    Contact = 'Contact',
    Account = 'Account',
    Credit = 'Credit',
    Demand = 'Demand',
    DemandCustomer = 'DemandCustomer',
    DemandAccountItem = 'DemandAccountItem',
    DemandItem = 'DemandItem',
    Inquiry = 'Inquiry',
    InquirySupplierAccount = 'InquirySupplierAccount',
    AccountPurchase = 'AccountPurchase',
    Invoice = 'Invoice',
    InvoiceTextItem = 'InvoiceTextItem',
    InvoiceItem = 'InvoiceItem',
    Offer = 'Offer',
    OfferItem = 'OfferItem',
    PurchaseOrder = 'PurchaseOrder',
    PurchaseOrderItem = 'PurchaseOrderItem',
    PurchaseItem = 'PurchaseItem',
    SalesOrder = 'SalesOrder',
    SalesOrderPosition = 'SalesOrderPosition',
    SalesOrderPositionItem = 'SalesOrderPositionItem',
    SupplierNotificationContact = 'SupplierNotificationContact',
    Product = 'Product',
    ProductAttribute = 'ProductAttribute',
    ProductAttributeTranslation = 'ProductAttributeTranslation',
    ProductPrice = 'ProductPrice',
    ProductSpecialPrice = 'ProductSpecialPrice',
    ProductTranslation = 'ProductTranslation',
}
